export const APP_CONFIG = {
  NAME: import.meta.env.VITE_APP_NAME || 'F.O.W',
  VERSION: import.meta.env.VITE_APP_VERSION || '1.0.0',
  ENV: import.meta.env.VITE_APP_ENV || 'development',
};

export const API_CONFIG = {
  BASE_URL: import.meta.env.VITE_API_BASE_URL || 'http://localhost:4000/api',
  TIMEOUT: parseInt(import.meta.env.VITE_API_TIMEOUT) || 30000,
};

export const STORAGE_KEYS = {
  ACCESS_TOKEN: 'access_token',
  REFRESH_TOKEN: 'refresh_token',
  USER: 'user',
  PERMISSIONS: 'permissions',
  THEME: 'theme',
  LANGUAGE: 'language',
  DASHBOARD_ACCESS: 'dashboard_access',
  PENDING_USER_ID: 'pending_user_id',
};

export const USER_ROLES = {
  ADMIN: 'admin',
  MENTOR: 'mentor',
  STUDENT: 'student',
};

export const HTTP_STATUS = {
  OK: 200,
  CREATED: 201,
  NO_CONTENT: 204,
  BAD_REQUEST: 400,
  UNAUTHORIZED: 401,
  FORBIDDEN: 403,
  NOT_FOUND: 404,
  CONFLICT: 409,
  UNPROCESSABLE_ENTITY: 422,
  INTERNAL_SERVER_ERROR: 500,
  SERVICE_UNAVAILABLE: 503,
};

export const ROUTES = {
  HOME: '/home',
  LOGIN: '/login',
  REGISTER: '/register',
  VERIFY_PHONE: '/verify-phone',
  VERIFY_EMAIL: '/verify-email',
  VERIFY_OTP: '/verify-otp',
  FORGOT_PASSWORD: '/forgot-password',
  RESET_PASSWORD: '/reset-password',
  DASHBOARD: '/home',
  PROFILE: '/profile',
  SETTINGS: '/settings',
  COMPLETE_PROFILE: '/complete-profile',
  PROFILE_VERIFICATION: '/profile-verification',
  PORTFOLIO_SETUP: '/portfolio-setup',
  STUDENT_DETAILS: '/portfolio/:studentId',
  TERMS_AND_CONDITIONS: '/terms-and-conditions',
  PRIVACY_POLICY: '/privacy-policy',
  FAQ: '/faq',
  OUR_JOURNEY: '/our-journey',
  BASE:'/',
  
  // Student Dashboard Routes
  STUDENT_DASHBOARD: '/student',
  STUDENT_CAREER_MAP: '/student/career-map',
  STUDENT_CAREER_ROADMAP: '/student/career-roadmap',
  STUDENT_CAREER_REPORT: '/student/career-report',
  STUDENT_SKILL_TRACKER: '/student/skill-tracker',
  STUDENT_PORTFOLIO: '/student/portfolio',
  STUDENT_MENTOR: '/student/mentor',
  STUDENT_MENTOR_DETAILS: '/student/mentor/:mentorId',
  STUDENT_OPPORTUNITY: '/student/opportunity',
  STUDENT_SCORE_CARD: '/student/score-card',
  STUDENT_REQUESTS: '/student/requests',
  STUDENT_MY_QUESTIONS: '/student/my-questions',
  STUDENT_QUESTION_DETAIL: '/student/questions/:questionId',
  STUDENT_MENTOR_CHAT: '/student/mentor/:mentorId/questions',
  STUDENT_PLAN_UPGRADE: '/student/plan-upgrade',
  
  NOTES: '/notes',
  CART: '/cart',
  CART_VIEW: '/cart/view',
  HISTORY: '/history',
  PAYMENT_HISTORY: '/payment-history',
  
  // Mentor Dashboard Routes
  MENTOR_DASHBOARD: '/mentor',
  MENTOR_QUESTIONS: '/mentor/questions',
  MENTOR_MENTORS_LIST: '/mentor/mentors',
  MENTOR_PROFILE_DETAILS: '/mentor/profile/:mentorId',
  MENTOR_EARNINGS: '/mentor/earnings',
  MENTOR_FEEDBACK: '/mentor/feedback',
  MENTOR_NOTIFICATIONS: '/mentor/notifications',
  MENTOR_VIDEOS: '/mentor/videos',
  MENTOR_PROFILE: '/mentor/profile',
  
  ADMIN_DASHBOARD: '/admin/dashboard',
  ADMIN_MENTORS: '/admin/mentors',
  ADMIN_MENTOR_DETAILS: '/admin/mentors/:mentorId',
  ADMIN_MENTOR_REVIEW: '/admin/mentors/:mentorId/review',
  ADMIN_STUDENTS: '/admin/students',
  ADMIN_STUDENT_DETAILS: '/admin/students/:studentId',
  ADMIN_DOCUMENTS: '/admin/documents',
  ADMIN_QUESTIONS: '/admin/questions',
  ADMIN_QUESTION_DETAILS: '/admin/questions/:questionId',
  ADMIN_PAYMENTS: '/admin/payments',
  ADMIN_PAYMENT_DETAILS: '/admin/payments/:questionId',
  ADMIN_MENTOR_BALANCES: '/admin/mentor-balances',
  ADMIN_FEEDBACK: '/admin/feedback',
  ADMIN_FEEDBACK_DETAILS: '/admin/feedback/:feedbackId',
  ADMIN_SUPPORT: '/admin/support',
  ADMIN_SUPPORT_TICKET: '/admin/support/:ticketId',
  ADMIN_ANALYTICS: '/admin/analytics',
  ADMIN_MANAGEMENT: '/admin/admin-management',
  ADMIN_SUBSCRIPTIONS: '/admin/subscriptions',
  ADMIN_SUBSCRIPTION_DETAILS: '/admin/subscriptions/:transactionId',
  ADMIN_CARTS: '/admin/carts',
  NOT_FOUND: '/404',
  UNAUTHORIZED: '/401',
  SERVER_ERROR: '/500',
};

export const LOG_LEVELS = {
  DEBUG: 'debug',
  INFO: 'info',
  WARN: 'warn',
  ERROR: 'error',
};

export const TOAST_TYPES = {
  SUCCESS: 'success',
  ERROR: 'error',
  WARNING: 'warning',
  INFO: 'info',
};

export const VALIDATION_MESSAGES = {
  REQUIRED: 'This field is required',
  EMAIL_INVALID: 'Please enter a valid email address',
  PASSWORD_MIN_LENGTH: 'Password must be at least 8 characters',
  PASSWORD_MISMATCH: 'Passwords do not match',
  PHONE_INVALID: 'Please enter a valid phone number',
};

export const DATE_FORMATS = {
  DISPLAY: 'MMM dd, yyyy',
  DISPLAY_WITH_TIME: 'MMM dd, yyyy HH:mm',
  ISO: "yyyy-MM-dd'T'HH:mm:ss.SSSxxx",
  API: 'yyyy-MM-dd',
};

export const PAGINATION = {
  DEFAULT_PAGE: 1,
  DEFAULT_LIMIT: 10,
  PAGE_SIZE_OPTIONS: [10, 25, 50, 100],
};

export const DOCUMENT_TYPES = {
  AADHAR: 'aadhar',
  DEGREE_CERTIFICATE: 'degree_certificate',
  EXPERIENCE_CERTIFICATE: 'experience_certificate',
};

export const DOCUMENT_STATUS = {
  PENDING: 'pending',
  APPROVED: 'approved',
  REJECTED: 'rejected',
};

export const VERIFICATION_STATUS = {
  PENDING: 'pending',
  APPROVED: 'approved',
  REJECTED: 'rejected',
};

export const OTP_TYPES = {
  EMAIL: 'email',
  PHONE: 'phone',
};
